import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, Bike, Users, MapPin, CreditCard, HeadphonesIcon, Settings, LogOut, Zap, Shield, Truck, Navigation, Package, ClipboardList, Wallet, DollarSign } from 'lucide-react';
interface SidebarProps {
  activePage: string;
  setActivePage: (page: string) => void;
}
export function Sidebar({
  activePage,
  setActivePage
}: SidebarProps) {
  const sections = [{
    title: 'Overview',
    items: [{
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard
    }]
  }, {
    title: 'Customer App',
    items: [{
      id: 'customers',
      label: 'Customers',
      icon: Users
    }, {
      id: 'deliveries',
      label: 'Deliveries',
      icon: Package
    }]
  }, {
    title: 'Rider App',
    items: [{
      id: 'riders',
      label: 'Riders',
      icon: Bike
    }, {
      id: 'jobs',
      label: 'Jobs',
      icon: ClipboardList
    }, {
      id: 'earnings',
      label: 'Earnings',
      icon: Wallet
    }]
  }, {
    title: 'Operations',
    items: [{
      id: 'dispatch',
      label: 'Live Dispatch',
      icon: Navigation
    }, {
      id: 'fleet',
      label: 'Fleet & Bikes',
      icon: Truck
    }, {
      id: 'pricing',
      label: 'Pricing',
      icon: DollarSign
    }, {
      id: 'audit',
      label: 'Audit Logs',
      icon: Shield
    }]
  }, {
    title: 'System',
    items: [{
      id: 'support',
      label: 'Support',
      icon: HeadphonesIcon
    }, {
      id: 'settings',
      label: 'Settings',
      icon: Settings
    }]
  }];
  return <div className="w-64 bg-famo-navy h-screen fixed left-0 top-0 flex flex-col text-white shadow-xl z-50" data-id="element-69">
      {/* Logo Area */}
      <div className="h-16 flex items-center px-6 border-b border-slate-800 flex-shrink-0" data-id="element-70">
        <div className="flex items-center gap-2 text-famo-gold" data-id="element-71">
          <Zap className="h-6 w-6 fill-current" data-id="element-72" />
          <span className="text-xl font-bold tracking-tight text-white" data-id="element-73">
            FAMO
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-6 px-3 space-y-6 overflow-y-auto" data-id="element-74">
        {sections.map((section, idx) => <div key={idx} data-id="element-75">
            <div className="px-3 mb-2 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-76">
              {section.title}
            </div>
            <div className="space-y-1" data-id="element-77">
              {section.items.map(item => {
            const isActive = activePage === item.id;
            const Icon = item.icon;
            return <button key={item.id} onClick={() => setActivePage(item.id)} className={`w-full flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 group relative ${isActive ? 'bg-slate-800/50 text-white font-medium' : 'text-slate-400 hover:bg-slate-800/30 hover:text-white'}`} data-id="element-78">
                    {isActive && <motion.div layoutId="activeIndicator" className="absolute left-0 w-1 h-6 bg-famo-gold rounded-r-full" initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                duration: 0.2
              }} data-id="element-79" />}
                    <Icon size={20} className={`mr-3 ${isActive ? 'text-famo-gold' : 'text-slate-500 group-hover:text-slate-300'}`} data-id="element-80" />
                    {item.label}
                  </button>;
          })}
            </div>
          </div>)}
      </nav>

      {/* User Profile */}
      <div className="p-4 border-t border-slate-800 flex-shrink-0" data-id="element-81">
        <div className="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-slate-800/50 cursor-pointer transition-colors" data-id="element-82">
          <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Admin" className="h-9 w-9 rounded-full border border-slate-600" data-id="element-83" />
          <div className="flex-1 min-w-0" data-id="element-84">
            <p className="text-sm font-medium text-white truncate" data-id="element-85">
              Admin User
            </p>
            <p className="text-xs text-slate-400 truncate" data-id="element-86">admin@famo.com</p>
          </div>
          <LogOut size={16} className="text-slate-500 hover:text-white" data-id="element-87" />
        </div>
      </div>
    </div>;
}